import type { ContractorTranslation } from './en';

export const ja: ContractorTranslation = {
  common: {
    cancel: 'キャンセル',
    save: '保存',
    retry: '再試行',
    download: 'ダウンロード',
    continue: '続ける',
    yes: 'はい',
    no: 'いいえ',
    genericError: '問題が発生しました。もう一度お試しください。',
    networkError: 'DubForgeに接続できません。インターネット接続を確認してください。',
  },
  app: {
    tagline: '吹き替えの依頼、ファイル、レビューをひとつの場所で。',
    startupFailed: 'DubForgeを起動できませんでした',
    notFoundTitle: 'ページが見つかりません',
    notFoundBody: 'このページは存在しないか、アクセス権がありません。',
    goHome: 'ホームに戻る',
    crashTitle: '問題が発生しました',
    crashBody: 'ページを再読み込みしてください。',
    reload: '再読み込み',
  },
  language: {
    label: '言語',
    change: '言語を変更',
  },
  welcome: {
    title: 'DubForgeへようこそ',
    body: '使用する言語を選んでください。DubForgeの画面とDiscordの通知がこの言語になります。',
    changeLater: 'あとから右上の言語メニューでいつでも変更できます。',
  },
  nav: {
    myAssignments: '自分の依頼',
    openMenu: 'メニューを開く',
    account: 'アカウント',
    notificationEmail: '通知用メールアドレス',
    signOut: 'ログアウト',
    roleAdmin: '管理者',
    roleContractor: '声優',
    lightMode: 'ライトモード',
    darkMode: 'ダークモード',
  },
  login: {
    signIn: 'Discordでログイン',
    onlyInvited: 'チャンネルのオーナーが追加したDiscordアカウントのみログインできます。',
    signingIn: 'ログインしています…',
    backToSignIn: 'ログイン画面に戻る',
    failed: 'ログインに失敗しました。もう一度お試しください。',
  },
  authErrors: {
    not_invited: 'このDiscordアカウントはDubForgeに追加されていません。チャンネルのオーナーに追加を依頼してください。',
    access_off: 'DubForgeへのアクセスは無効になっています。',
    discord_only: 'Discordでのみログインできます。',
  },
  errors: {
    not_signed_in: 'セッションの有効期限が切れました。もう一度ログインしてください。',
    access_off: 'DubForgeへのアクセスは無効になっています。',
    admins_only: 'この操作を行う権限がありません。',
    not_found: 'この項目は存在しないか、利用できなくなっています。',
    invalid_request: 'リクエストの内容に問題があります。確認してもう一度お試しください。',
    conflict: 'すでに存在します。',
    already_approved: 'この依頼はすでに承認されているため、これ以上のアップロードは不要です。',
    not_audio: 'アップロードできるのはWAVまたはMP3ファイルのみです。自分の音声トラックだけをアップロードしてください。',
    upload_incomplete: 'アップロードが完了しませんでした。もう一度お試しください。',
    discord_unreachable: 'Discordに接続できません。しばらくしてからもう一度お試しください。',
    server_error: 'サーバー側で問題が発生しました。もう一度お試しください。',
  },
  notifications: {
    title: '通知',
    openWithCount: '通知（未読{{count}}件）',
    markAllRead: 'すべて既読にする',
    empty: 'まだ通知はありません。',
  },
  emailSettings: {
    body: '新しい依頼が届いたときや、レビューが終わったときにメールでお知らせします。',
    label: 'メールアドレス',
    fromDiscord: 'Discordアカウントのメールアドレスを使用しています。別のアドレスを使う場合は変更してください。',
    saved: 'メールアドレスを保存しました',
    invalid: '有効なメールアドレスを入力してください。',
    missing: 'メールアドレスが未登録です。通知を受け取るには追加してください。',
  },
  status: {
    Assigned: '依頼済み',
    InProgress: '作業中',
    Submitted: 'レビュー待ち',
    ChangesRequested: '修正依頼あり',
    Approved: '承認済み',
  },
  assetKind: {
    package: '吹き替えパッケージ（動画＋音声＋SFX）',
    video: '参考動画（720p）',
    sfx: 'SFX／音楽トラック',
    voice: '元の音声トラック',
    script: '台本',
    other: 'その他',
  },
  translation: {
    machine: '機械翻訳',
    showOriginal: '原文を表示',
    showTranslation: '翻訳を表示',
  },
  uploader: {
    progress: '{{percent}}%（{{size}}中）',
    queued: 'アップロード待ち：{{count}}件',
    keepOpen: '完了するまでこのタブを開いたままにしてください。',
    cancelled: 'アップロードをキャンセルしました',
    done: '{{name}}をアップロードしました',
    failed: 'アップロードに失敗しました：{{error}}',
  },
  my: {
    greeting: 'こんにちは、{{name}}さん',
    subtitle: 'あなたの吹き替え依頼です。',
    emptyTitle: 'まだ依頼はありません',
    emptyBody: '動画が割り当てられるとDiscordにメッセージが届き、ここに表示されます。',
    todo: '未対応',
    waiting: 'レビュー待ち',
    done: '完了',
    updated: '{{when}}に更新',
  },
  assignment: {
    back: '自分の依頼',
    dubIn: '吹き替え：{{language}}',
    paid: '支払い済み',
    next: {
      Assigned: '素材ファイルをダウンロードして声を録音し、ここに音声トラックをアップロードしてください。',
      InProgress: '音声トラックの準備ができたら、下からアップロードしてください。',
      Submitted: '吹き替えをレビューに提出しました。レビューが終わるとDiscordにメッセージが届きます。',
      ChangesRequested: '修正依頼があります。下のフィードバックを確認して、新しいバージョンをアップロードしてください。',
      Approved: '承認されました。ありがとうございました！',
    },
    notes: 'メモ',
    sourceFiles: '素材ファイル',
    noFiles: 'まだファイルはアップロードされていません。',
    fileInfo: '{{kind}}・{{size}}',
    packageHint: '動画と2つの音声トラックを含む1つの.mp4ファイルです。トラック1は元のセリフ、トラック2はSFXです。',
    uploadTitle: '音声トラックをアップロード',
    voiceOnlyTitle: '自分の声だけ',
    voiceOnlyBody: '録音した自分の声だけをアップロードしてください。音楽、効果音、元の音声は含めないでください。長さは元の音声と同じにしてください。',
    voiceOnlyConfirm: 'このファイルにはセリフの音声だけが入っています。',
    dropLabel: '音声トラックをここにアップロード',
    dropHint: 'WAVまたはMP3のみ。',
    noteForReviewer: 'レビュー担当者へのメモ（任意）',
    lengthTitle: '長さが一致しません',
    lengthBody:
      'ファイルの長さは{{dub}}ですが、SFXトラックは{{sfx}}です。開始位置が違ったり途中で切れていたりすると、動画と合いません。このままアップロードしますか？',
    uploadAnyway: 'このままアップロード',
    chooseAnother: '別のファイルを選ぶ',
    versions: 'アップロードしたバージョン',
    nothingUploaded: 'まだ何もアップロードされていません。',
    version: 'バージョン{{version}}',
    reviewApproved: '承認済み',
    reviewChanges: '修正依頼あり',
    reviewPending: 'レビュー待ち',
    yourNote: 'あなたのメモ：',
    feedback: 'フィードバック',
    listen: '再生',
    uploadedOn: '{{date}}・{{size}}',
    length: '長さ：{{duration}}',
  },
};
